import { Pipe } from '@angular/core';
import * as filesize from 'filesize';
var FileSizePipe = /** @class */ (function () {
    function FileSizePipe() {
    }
    FileSizePipe.prototype.transform = function (value, options) {
        if (Array.isArray(value)) {
            return value.map(function (val) { return FileSizePipe.transformOne(val, options); });
        }
        return FileSizePipe.transformOne(value, options);
    };
    FileSizePipe.transformOne = function (value, options) {
        return filesize(value, options);
    };
    FileSizePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'filesize'
                },] },
    ];
    return FileSizePipe;
}());
export { FileSizePipe };
//# sourceMappingURL=filesize.pipe.js.map